import { stripHTML } from '@adobe/edex/ui/shared/frontend/utils/sanitize';
import { DEFAULT_DOCUMENT_TITLE } from '@adobe/edex/ui/shared/constants';

export const formatDocumentTitle = (title: string) => {
  const name = DEFAULT_DOCUMENT_TITLE;
  if (title) {
    const postfix = `| ${name}`;
    return title.endsWith(postfix) ? title : `${title} ${postfix}`;
  } else {
    return name;
  }
};

export function getCourseSeoProps(course): { title: string; description: string; heroImage: string } {
  if (!course) {
    return null;
  }
  const { settings, heroImageURL } = course;
  return {
    title: formatDocumentTitle(settings?.seo?.title || course.title),
    description: settings?.seo?.metaDescription || stripHTML(course.description),
    heroImage: heroImageURL,
  };
}

export function getStaticPageSeoProps(staticPage) {
  if (!staticPage) {
    return null;
  }
  return {
    title: formatDocumentTitle(staticPage.title),
    description: stripHTML(staticPage.description),
    image: staticPage.image,
  };
}
